import { render, staticRenderFns } from "./InShopDetails.vue?vue&type=template&id=c527ba4c"
import script from "./InShopDetails.vue?vue&type=script&lang=js"
export * from "./InShopDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports